/* eslint-disable no-unused-vars */
export enum ApolloContextKey {
  CUSTOM_OPERATION_NAME = 'custom_operation_name',
}
